import type { Property } from 'csstype';
import type { ThemeUICSSObject } from 'theme-ui';

import type { ResponsiveArrayValue } from '@change-corgi/design-system-legacy/theme';

import { createBreakpointValuesGetter } from './getBreakpointValues';

/**
 * @doc $DOC:ResponsiveHooks/DisplayBreakpointValuesGetter
 */
export const getDisplayBreakpointValues = createBreakpointValuesGetter<Property.Display, 'block', 'none'>(
	'block',
	'none',
);

/**
 * @doc $DOC:ResponsiveHooks/DisplayBreakpointStylesGetter
 */
export function getDisplayBreakpointStyles(
	values: ResponsiveArrayValue<boolean>,
	trueValue: Property.Display = 'block',
	falseValue: Property.Display = 'none',
): ThemeUICSSObject {
	return {
		display: getDisplayBreakpointValues(values, trueValue, falseValue),
	};
}
